class WysiwygEditorController {
  constructor($scope, $element, $timeout, $attrs) {
    "ngInject";
    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.$attrs = $attrs;
    
    // Generate unique ID for this editor instance
    this.editorId = 'wysiwyg-editor-' + Math.random().toString(36).substr(2, 9);
    this.editorInstance = null;
    
    // Initialize content from ngModel
    this.content = this.ngModel || '';
    
    // Watch for external changes to ngModel
    $scope.$watch(() => this.ngModel, (newVal) => {
      if (newVal !== this.content && this.editorInstance) {
        this.content = newVal || '';
        this.editorInstance.setContent(this.content);
      }
    });
    
    // Watch for disabled state changes
    $scope.$watch(() => this.disabled, (newVal) => {
      if (this.editorInstance) {
        this.editorInstance.mode.set(newVal ? 'readonly' : 'design');
      }
    });
    
    // Initialize TinyMCE after view is ready
    $timeout(() => {
      this.initEditor();
    }, 100);
    
    // Cleanup on destroy
    $scope.$on('$destroy', () => {
      this.destroyEditor();
    });
  }
  
  initEditor() {
    const self = this;
    
    // Check if TinyMCE is available
    if (typeof tinymce === 'undefined') {
      console.error('TinyMCE is not loaded. Please include TinyMCE script.');
      return;
    }
    
    // Default configuration
    const defaultConfig = {
      selector: '#' + this.editorId,
      height: parseInt(this.height) || 300,
      menubar: false,
      readonly: this.disabled || false,
      plugins: [
        'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
        'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
        'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
      ],
      toolbar: 'undo redo | formatselect | ' +
        'bold italic backcolor | alignleft aligncenter ' +
        'alignright alignjustify | bullist numlist outdent indent | ' +
        'removeformat | help',
      content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
      setup: (editor) => {
        self.editorInstance = editor;
        
        // Update ngModel when content changes
        editor.on('change keyup', () => {
          const content = editor.getContent();
          self.content = content;
          if (self.ngModel !== content) {
            self.$scope.$apply(() => {
              self.ngModel = content;
              if (self.onChange) {
                self.onChange({ content: content });
              }
            });
          }
        });
        
        // Handle blur event
        editor.on('blur', () => {
          const content = editor.getContent();
          self.content = content;
          self.$scope.$apply(() => {
            self.ngModel = content;
            if (self.onBlur) {
              self.onBlur({ content: content });
            }
          });
        });
      }
    };
    
    // Merge with custom config if provided
    const config = angular.extend({}, defaultConfig, this.config || {});
    
    // Initialize TinyMCE
    tinymce.init(config);
  }
  
  onContentChange() {
    if (this.editorInstance && this.content !== this.editorInstance.getContent()) {
      this.editorInstance.setContent(this.content || '');
    }
  }
  
  destroyEditor() {
    if (this.editorInstance) {
      tinymce.remove('#' + this.editorId);
      this.editorInstance = null;
    }
  }
}

export default WysiwygEditorController;




// WEBPACK FOOTER //
// ./client/common/directives/wysiwyg-editor/wysiwyg-editor.controller.js